import catalogs from "./locales.json";

export function normalizeLocale(value: string | undefined): string {
  const code = (value || "en").toLowerCase().split(/[-_]/)[0];
  return ["en", "fr", "it", "es", "ru"].includes(code) ? code : "en";
}

export function translator(locale: string) {
  const catalog = (catalogs as Record<string, Record<string, string>>)[normalizeLocale(locale)] || {};
  return (message: string, values: Record<string, string | number> = {}): string =>
    (catalog[message] ?? message).replace(/\{(\w+)\}/g, (all, name) => String(values[name] ?? all));
}
